/**
 * Copyright (c) 2026-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Remix Icon License v1.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const GithubFill = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 6.84 9.49c.5.09.69-.21.69-.48l-.02-1.86c-2.5.46-3.16-.61-3.36-1.17-.11-.3-.6-1.18-1.02-1.42-.35-.19-.85-.65-.02-.66.8-.01 1.35.72 1.54 1.02.9 1.52 2.34 1.1 2.91.83a2 2 0 0 1 .64-1.34c-2.22-.25-4.55-1.11-4.55-4.94 0-1.08.39-1.98 1.03-2.68a3.6 3.6 0 0 1 .1-2.65s.83-.27 2.75 1.02a9 9 0 0 1 2.5-.34q1.29 0 2.5.34c1.9-1.3 2.75-1.02 2.75-1.02.55 1.37.2 2.4.1 2.65.63.7 1.02 1.58 1.02 2.68 0 3.84-2.34 4.7-4.56 4.94.36.31.67.91.67 1.85v2.75c0 .26.18.58.68.48A10 10 0 0 0 22 12 10 10 0 0 0 12 2" />
  </Icon>
);
